import { NgModule } from '@angular/core';
import { PipeAdjustData } from './pipeAdjustData';
import { PipeDateBrasil } from './pipeDateBrasil';
import { PipeDate } from './pipeDate';
import { PipeHora } from './pipeHora';
import { PipeHoraBrasil } from './pipeHoraBrasil';
import { SafePipe } from './pipeLinkSafe';
import { PipeLimiteCaractere } from './pipeLimiteCaractere';
import { PipeDomSanitizer } from './pipeDomSanitizer';
import { PipeStatusCron } from './pipeStatusCron';
import { PipeStatusCron2 } from './pipeStatusCron2';
import { PipeStatusReport } from './pipeStatusReport';
import { PipeCountPlan } from './pipeCountPlan';
import { PipeTypeBilling } from './pipeTypeBilling';
import { PipeTypeExcess } from './pipeTypeExcess';
import { EndpointsFilterPipe } from './pipeEndpointsFilters';
import { EndpointsFilter2Pipe } from './pipeEndpointsFilter2';
import { EndpointsColorPipe } from './pipeEndpointsColor';
import { EndpointsFilterDescriptionPipe } from './pipeEndpointsFiltersDescription';
import { PipeCalendarStatus } from './pipeCalendarStatus';
import { PipeDurationStatus } from './pipeDurationStatus';
import { PipeDurationStatusSimple } from './pipeDurationStatusSimple';
import { PipeSeparateDate } from './pipeSeparateDate';
import { PipeDateSimple } from './pipeDateSimple';
import { PipeStatusMqtt } from './pipeStatusMqtt';
import { PipeLiveMqtt } from './pipeLiveMqtt';
import { PipeUpdatedAtMqtt } from './pipeUpdatedAtMqtt';
import { PipeLimiteCaractere2 } from './pipeLimiteCaractere2';
import { PipeLimiteCaractere3 } from './pipeLimiteCaractere3';

@NgModule({
    declarations: [
        PipeAdjustData, 
        SafePipe, 
        PipeDateBrasil, 
        PipeDate,
        PipeHora,
        PipeHoraBrasil, 
        PipeLimiteCaractere, 
        PipeDomSanitizer, 
        PipeStatusCron,
        PipeStatusCron2,
        PipeStatusReport, 
        PipeCountPlan,
        PipeTypeBilling,
        PipeTypeExcess,
        EndpointsFilterPipe,
        EndpointsFilter2Pipe,
        EndpointsColorPipe,
        EndpointsFilterDescriptionPipe,
        PipeCalendarStatus,
        PipeDurationStatus,
        PipeDurationStatusSimple,
        PipeSeparateDate,
        PipeDateSimple,
        PipeStatusMqtt,
        PipeLiveMqtt,
        PipeUpdatedAtMqtt,
        PipeLimiteCaractere2,
        PipeLimiteCaractere3
    ],
    imports: [],
    exports: [
        PipeAdjustData, 
        SafePipe, 
        PipeDateBrasil, 
        PipeDate,
        PipeHora,
        PipeHoraBrasil, 
        PipeLimiteCaractere, 
        PipeDomSanitizer, 
        PipeStatusCron,
        PipeStatusCron2,
        PipeStatusReport,
        PipeCountPlan,
        PipeTypeBilling,
        PipeTypeExcess,
        EndpointsFilterPipe,
        EndpointsFilter2Pipe,
        EndpointsColorPipe,
        EndpointsFilterDescriptionPipe,
        PipeCalendarStatus,
        PipeDurationStatus,
        PipeDurationStatusSimple,
        PipeSeparateDate,
        PipeDateSimple,
        PipeStatusMqtt,
        PipeLiveMqtt,
        PipeUpdatedAtMqtt,  
        PipeLimiteCaractere2,
        PipeLimiteCaractere3
    ]
})

export class PipesModule{

}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/PipesModule.ts